import { Dialog, DialogTitle, DialogContent, TextField, Typography, DialogActions, Button, Alert } from "@mui/material";
import { ClientUpdatePassword } from "api/client";
import React, { useState } from "react";
import Swal from "sweetalert2";

const ClientChangePasswordDialog = ({
    open,
    setOpen,
}) => {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");

    const handleSave = () => {
        if (newPassword !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }
        if (newPassword.length < 8) {
            setError("Password must be at least 8 characters long including a number and letter");
            return;
        }
        if (!/\d/.test(newPassword) || !/[a-zA-Z]/.test(newPassword)) {
            setError("Password must contain at least one letter and one number");
            return;
        }
        setError("");
        // Call the API to change the password
        ClientUpdatePassword(oldPassword, newPassword)
            .then((response) => {
                if (response.error || (response.status !== 200 && response.status !== 201)) {
                    setError(response.message || "Failed to change password");
                } else {
                    setError("");
                    Swal.fire({
                        icon: "success",
                        title: "Password Changed",
                        text: "Your password has been changed successfully.",
                    });
                    // Reset the form fields and close dialog only on success
                    setOldPassword("");
                    setNewPassword("");
                    setConfirmPassword("");
                    setOpen(false);
                }
            })
            .catch((err) => {
                console.error(err);
                setError("An error occurred while changing the password.");
            });
    };

    return (
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Typography variant="h5" color="secondary">Change Password</Typography>
            </DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    id="old-password"
                    margin="dense"
                    label="Current Password"
                    type="password"
                    fullWidth
                    variant="standard"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                />
                <TextField
                    margin="dense"
                    label="New Password"
                    type="password"
                    fullWidth
                    variant="standard"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />
                <TextField
                    margin="dense"
                    label="Confirm Password"
                    type="password"
                    fullWidth
                    variant="standard"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />
                {error && <Alert severity="error" sx={{marginTop: 1}}>{error}</Alert>}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)} color="secondary">Cancel</Button>
                <Button onClick={handleSave} color="secondary">Save</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ClientChangePasswordDialog;